import { useEffect, useRef, useState } from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

export function OfflineToast() {
  const isOnline = useOnlineStatus();
  const [flash, setFlash] = useState<'restored' | null>(null);
  const wasOffline = useRef(false);

  useEffect(() => {
    if (!isOnline) {
      wasOffline.current = true;
      setFlash(null);
    } else if (wasOffline.current) {
      wasOffline.current = false;
      setFlash('restored');
      const t = setTimeout(() => setFlash(null), 3000);
      return () => clearTimeout(t);
    }
  }, [isOnline]);

  if (isOnline && !flash) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'fixed left-4 right-4 top-4 z-[100] flex items-center gap-3 rounded-2xl px-4 py-3 text-sm font-semibold text-white shadow-xl',
        !isOnline ? 'bg-slate-800' : 'bg-green-600',
      )}
    >
      {!isOnline
        ? <WifiOff className="h-4 w-4 shrink-0" aria-hidden="true" />
        : <Wifi className="h-4 w-4 shrink-0" aria-hidden="true" />
      }
      {!isOnline ? 'Sem conexão com a internet' : 'Conexão restaurada'}
    </div>
  );
}
